import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

export const SKIP_LOADER  = new HttpContextToken<boolean>(() => false);

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoadingService);

  if(req.context.get(SKIP_LOADER)) {
    return next(req);
  }

  const blocked = loader.isBlockedUrl(req.url);
  if (!loader.overlayBlocked() && !blocked) loader.add(req.url);
  return next(req).pipe(
    finalize(() => {
      loader.remove(req.url);
    })
  )
};
